import { render, staticRenderFns } from "./UrlParameter.vue?vue&type=template&id=acda70e8"
import script from "./UrlParameter.vue?vue&type=script&lang=js"
export * from "./UrlParameter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports